const NET = "https://appointy-backend.herokuapp.com"
// const PORT ="http://localhost:3000"
const API = `${NET}/api/v1`;
export default API;